import { Logger } from 'src/core/logger/logger';
import { LMS_COLUMNS } from 'src/config/app.config';
import { LmsModel } from 'src/core/model/quarter-overview.model';
import { csvStringToFloat } from '../quarter-overview.utils';

type ParsedLmsHeaders = Required<Record<keyof LmsModel, number>>;

export function parseLmsHeader(line: any[]): ParsedLmsHeaders {
  const headers = Object.entries(LMS_COLUMNS);

  const result: ParsedLmsHeaders = {
    id: -1,
    date: -1,
    chargePointName: -1,
    connectorId: -1,
    customerId: -1,
    name: -1,
    externalCardId: -1,
    internalCardId: -1,
    global: -1,
    energyDelivered: -1,
    totalHT: -1,
    durationInMin: -1,
  };

  headers.forEach(([key, value]) => {
    const colIndex = line.findIndex((item) => item === value);

    if (colIndex < 0) {
      Logger.error(`[LMS-FILE]: Column ${value} not found.`);
      return;
    }

    result[key as keyof LmsModel] = colIndex;
  });

  return result;
}

export function parseLmsLine(line: any[], config: ParsedLmsHeaders): LmsModel {
  return {
    id: config.id >= 0 ? line[config.id] : '',
    ...(config.date >= 0 && { date: line[config.date] }),
    ...(config.chargePointName >= 0 && {
      chargePointName: line[config.chargePointName],
    }),
    ...(config.connectorId >= 0 && {
      connectorId: line[config.connectorId],
    }),
    ...(config.customerId >= 0 && {
      customerId: line[config.customerId],
    }),
    ...(config.name >= 0 && { name: line[config.name] }),
    ...(config.externalCardId >= 0 && {
      externalCardId: line[config.externalCardId],
    }),
    ...(config.internalCardId >= 0 && {
      internalCardId: line[config.internalCardId],
    }),
    ...(config.global >= 0 && { global: line[config.global] }),

    ...(config.energyDelivered >= 0 && {
      energyDelivered: csvStringToFloat(line[config.energyDelivered]),
    }),

    ...(config.totalHT >= 0 && {
      totalHt: csvStringToFloat(line[config.totalHT]),
    }),
  };
}

export function parseLms(header: any[], lines: any[]): LmsModel[] {
  const lmsHeaders = parseLmsHeader(header);

  return lines.map((item) => parseLmsLine(item, lmsHeaders));
}
